<template>
  <div>
    <div class="top">
      <div class="center">
        <ul>
          <li>
            <img src="@/assets/images/image16.png" alt="">
            <span>独立三方</span>
          </li>
          <li>
            <img src="@/assets/images/image17.png" alt="">
            <span>质量保证</span>
          </li>
          <li>
            <img src="@/assets/images/image18.png" alt="">
            <span>报告准时</span>
          </li>
          <li>
            <img src="@/assets/images/image19.png" alt="">
            <span>延期赔付</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="bottom">
      <img class="logo" src="@/assets/images/logo2.png" alt="">
      <div class="nav">
        <div @click="$router.push('/aboutUs/enterpriseIntroduction')">关于我们</div>|
        <div @click="$router.push('/ourService/ourServiceMainPage')">我们的服务</div>|
        <div @click="$router.push('/joinUs')">加入我们</div>
      </div>
      <div class="phone">
        <img src="@/assets/images/image109.png" alt="">
        <div class="phoneNumber">0851-84439909</div>
      </div>
      <div class="info">
        <div>Copyright © 2023  健安德官网 jiandee.com All Rights Reserved.  </div>
        <div class="beian">
            <div @click="open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=52011302004817')">
                <img src="@/assets/images/beian.png" alt="">
                <span>贵公网安备 52011302004817号</span>
            </div>
            <span @click="open('https://beian.miit.gov.cn/#/Integrated/index')">备案号：黔ICP备2022008873号-1</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cusFooter',
  data () {
    return {
      input:""
    }
  },
  methods: {
    open(url){
        window.open(url)
    }
  },
}
</script> 

<style lang='less' scoped>
  .center{
    width: 1440px;
    margin: 0 auto;
    height: 100%;
  }
  .top{
    height: 80px;
    width: 100%;
    background-color: #DB0000;
    ul{
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 100%;
      li{
        color: white;
        display: flex;
        align-items: center;
        img{
          margin-right: 15px;
        }
      }
    }
  }
  .bottom{
    height: 342px;
    width: 100%;
    background-color: rgb(51, 51, 51);
    box-sizing: border-box;
    padding: 60px 0 30px 0;
    .logo{
      height: 44px;
      width: 225px;
      margin: 0 auto;
      display: block;
    }
    .nav{
      color: white;
      display: flex;
      justify-content: center;
      margin-top: 50px;
      div{
        width: 250px;
        text-align: center;
        cursor: pointer;
      }
    }
    .phone{
      margin-top: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      img{
        height: 40px;
        width: 40px;
        margin-right: 20px;
      }
      .phoneNumber{
        height: 52px;
        line-height: 52px;
        color: white;
        font-weight: bold;
        font-size: 36px;
      }
    }
    .info{
      color: #999999;
      margin-top: 28px;
      text-align: center;
      font-size: 14px;
      .beian{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 3px;
        &>div{
            display: flex;
            align-items: center;
            cursor: pointer;
            &:hover{
                color: white;
            }
            margin-right: 20px;
        }
        img{
            margin-right: 5px;
        }
        span{
            cursor: pointer;
            &:hover{
                color: white;
            }
        }
      }
    }
  }
</style>
